import { NotFoundContent } from '@/components/not-found/NotFoundContent'

export const NotFoundPage = () => <NotFoundContent />
